export const TypeOfMetrics = {
	variable: '$name: String!',
	query: `typeOfMetrics(name: $name)`
};

export const getAllTemplates = {
	query: `
    getAllTemplates(includingDisabled: false) {
      name,
      type
      configuration,
      activated,
      disabled,
    }
  `
};

export const addTemplate = {
	variable: '$setting: DashboardSetting!',
	query: `
    addTemplate(setting: $setting) {
      status
      message
    }
  `
};

export const changeTemplate = {
	variable: '$setting: DashboardSetting!',
	query: `
    changeTemplate(setting: $setting) {
      status
      message
    }
  `
};

export const disableTemplate = {
	variable: '$setting: DashboardSetting!',
	query: `
    disableTemplate(setting: $setting) {
      status
      message
    }
  `
};

export const slowTraces = {
	variable: [
		'$endpointId: ID!',
		'$endpointName: String!',
		'$duration: Duration!'
	],
	query: `
  slowTraces: queryBasicTraces(condition: {
		endpointId: $endpointId,
		endpointName: $endpointName,
		queryOrder: BY_DURATION,
    traceState: ALL,
    paging: {
          pageNum: 1,
          pageSize: 20,
          needTotal: false
      },
      queryDuration: $duration,
	}) {
      traces {
        key: segmentId
        endpointNames
        duration
        start
        isError
        traceIds
      }
      total
    }`
};

export const MetaData = {
	variable: ['$condition: ScopedMetaDataRequest!'],
	query: `
  response: readAggregatedScopedMetrics(condition: $condition) {
    records {
      name
      id
      calls
      errors
      errorPercent
      errors
      epm
      respTime
      cpm
      isDefaultName
      correlatedServiceId
      correlatedCapability
      isCorrelationAvailable
      correlatedInstanceId
      correlatedCapSubType
      isActive
      codeProfileEnabled
      isQualifiedVersion
    }
    total
  }`
};

export const SampleRecords = {
	variable: ['$condition: TopNCondition!,$duration: Duration!'],
	query: `
  response: readSampledRecords(condition:$condition, duration: $duration)  {
    name,
    id,
    value
  }`
};

export const AllSampleRecords = {
	variable: [
		'$condition: AllCondition!,$duration: Duration!, $pagination: Pagination!,$sortCriteria: [SortCriteria!]'
	],
	query: `
  readAllSampledRecords(condition:$condition, duration: $duration, pagination: $pagination, sortCriteria: $sortCriteria) {
    total,
    records {
      name,
      id,
      value,
      timestamp,
      count
    }
  }`
};

export const getCapabilityCorrelation = {
	variable: '$condition: CapabilityCorrelatedOverviewCondition!',
	query: `
  getCapabilityCorrelatedOverviewData(condition: $condition) {
    total
    correlatedCapability
    correlatedRecords {
      correlatedId
      correlatedName
      cpu
      ram
      storage
      network
      subType
      availability
      correlatedServiceId
    }
  }`
};

export const getActiveInstancesCount = {
  variable: ['$serviceId: ID!', '$duration: Duration!'],
  query: `
  getActiveInstancesCount(serviceId: $serviceId, duration: $duration){
    activeInstancesCount
  }
  `
};

export const downloadAllRecords = {
  variable: [
		'$condition: AllCondition!,$duration: Duration!'
	],
	query: `
  downloadAllSampleRecords(condition:$condition, duration: $duration) {
    total,
    records {
      name,
      id,
      value,
      timestamp,
      count
    }
  }`
};

export const getProfiles = {
  variable: '$request: ContinuesProfileDashboardRequest!',
  query: `response: findCodeProfile(request: $request) {
    id,
    status,
    displayMsg,
    message,
    isQualifiedVersion
    continuesProfileRespList  {
        metaId
        serviceId
        instanceId
        enable
        profilesList
        createdBy
        modifiedBy
        samples
        timePeriod
        startTime
        endTime
    }
}`,
};

export const getSocketIO = {
  variable: '$request: ProfilerCommonRequest',
  query: `fetchSocketIO(request: $request) {
    status
    message
    displayMessage
   socketResponse {
        remoteAddress,
        totalCount,
        ioTime,
        readCount,
        bytesRead,
        bytesWrite,
        writeCount,
        distinctPorts {
            port
            totalCount,
            ioTime,
            readCount,
            bytesRead,
            bytesWrite,
            writeCount,
            remotePorts {
                duration
                port
                timeout
                bytesRead
                bytesWrite
                hostName
                threadId
                threadName
            } 
        }
      }
  }`,
};

export const getGarbageCollectionData = {
  variable: '$request: ProfilerCommonRequest',
  query: `data: fetchGarbageCollectionInfo(request: $request) {
    status
    message
    displayMessage
    gcList {
            gcId,
            cause,
            collectorName,
            longestPause,
            sumOfPauses
        }
  }`
}

export const getHeapAndMetaSummaryData = {
  variable: '$request: ProfilerCommonRequest',
  query: `data: fetchHeapAndMetaSummary(request: $request) {
    status
    message
    displayMessage
            heapSummary {
                heapReservedSize,
                heapUsed,
                heapUsedPostGC,
                heapCommittedSize,
                createdAt
            },
            metaPhaseSummary {             
                startTime,
                gcThreshold,
                metaspaceCommitted,
                metaspaceUsed,
                metaspaceReserved,
                dataSpaceCommitted,
                dataSpaceUsed,
                dataSpaceReserved,
                classSpaceCommitted,
                classSpaceUsed,
                classSpaceReserved
            }
  }`
}

export const getTlabAllocationData = {
  variable: '$request: ProfilerCommonRequest!',
  query: `tlabTableResponse: getTLABAllocationTable(request: $request) {
    tLABAllocations {
        entityId
        entity
        allocationInTLAB
        allocationInTLABPercent
        allocationOutsideTLAB
        allocationOutsideTLABPercent
    }
    totalInTLABAllocation
    totalOutsideAllocation
    totalEntity
}`
}
export const getGCConfig = {
  variable: '$request: ProfilerCommonRequest',
  query: `fetchGarbageConfiguration(request: $request) {
    status
    message
    displayMessage
            gcConfiguration {
                youngCollector
                oldCollector
                dynamicGcThreads
                explicitGcConcurrent
                explicitGcDisabled
                parallelGcThreads
                concurrentGcThreads
                pauseTarget
                gcTimeRatio

            },
            heapConfiguration {
                minHeapSize
                maxHeapSize
                initialHeapSize
                compressedOopsMode
                compressedOopsModeUsed
                objectAlignment
                startTime
            },
            youngGCConfiguration {
                minYoungGenSize
                maxYoungGenSize
                newRatio
                initialTenuringThreshold
                maxTenuringThreshold
                tLabUsed
                minimumTLabSize
                refillWasteLimit
            }
  }`,
};

export const getMethodProfile = {
  variable: '$request: ProfilerCommonRequest',
  query: `  fetchMethodProfilingInfo(request: $request) {
    status
    message
    displayMessage
    methodProfilingResponse {
            total 
            methodProfilingList {
                percentage,
                methodName,
                methodCount,
                threadId,
                created
            }
        }
  }`,
};

export const getInstanceMemory = {
  variable: '$request: ProfilerCommonRequest!',
  query: `memoryInfoResponse: getMemoryDataOfClassList(request: $request) {
    totalMemory
    totalCount
    metricUnit
    memoryClassAllocations {
        className
        allocationSize
        allocationPercent
    }
  }`,
};

export const getStackTraceByThread = {
  variable: '$request: ThreadProfilerRequest',
  query: `  findStacktraceByThreadId(request: $request) {
    threadId
    threadName
    status
    message
   stack {
        lineNumber,
        bytecodeIndex,
        type,
        method,
        methodName,
        duration,
        samples,
        percentage
      }
  }`,
};

export const getThreadInfoByInstanceId = {
  variable: '$request: ProfilerCommonRequest',
  query: ` fetchThreadInfoByInstanceId(request: $request) {
    status
    message
    totalCount
    threadInfoListData {
      threadId
      threadName
      threadInfos {
          state
          lifespan
          startAt
          endAt
      }
    }
  }`,
};
export const getMetaInfoByGCId = {
  variable: '$request: JVMConfigurationRequest',
  query: `data: fetchMetaInfoByGCID(request: $request) {
    status
    message
    displayMessage
    gcList {
            pausePhaseList {
                gcId,
                name,
                eventType,
                duration,
                startTime
            },
            metaPhaseList {
                gcId,
                when,
                startTime,
                gcThreshold,
                metaspaceCommitted,
                metaspaceUsed,
                metaspaceReserved,
                dataSpaceCommitted,
                dataSpaceUsed,
                dataSpaceReserved,
                classSpaceCommitted,
                classSpaceUsed,
                classSpaceReserved
            }
        }
  }`
};

export const getTlabSummary = {
  variable: '$request: ProfilerCommonRequest!',
  query: `respone: getTLABSummary(request: $request) {
    tLABInAllocationSummary {
        tLABCount
        maxSize
        minSize
        avgTLABSize
        allocationTLAB
    }
    tLABOutsideAllocationSummary {
        tLABCount
        maxSize
        minSize
        avgTLABSize
        allocationTLAB
    }
}`
};

export const getTlabGraphData = {
  variable: '$request: ProfilerCommonRequest!',
  query: `tlabGraph: getTLABGraph(request: $request) {
    inTLAB {
        tlabSize
        startTime
    }
    outsideTLAB {
         tlabSize
        startTime
    }
} `
}
